import React from "react";
import { getLogo } from "../variables/DV";

const MainLogo = () => {
    return <img src={getLogo().logo} alt="logo" width={200} />;
};

export default MainLogo;
